import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { IntroContext } from '@components/Intro/context.ts';
import { v4 as uuidv4 } from 'uuid';

import { ENV } from '@/common/app/env';
import { Assistant } from '@/components/ui/Assistant/Assistant';
import { useModal } from '@/context/ModalContext';
import { useAppSelector } from '@/redux/store';

import { useHelpTypeFunction } from './returnHelpTypeFunction';
import useBoostHelp from './useBoostHelp';

import helpAssistantPng from '/img/icons/helpCards/help-assistant.png';
import helpAssistantWebp from '/img/icons/helpCards/help-assistant.webp';

const HelpIcon: React.FC = () => {
  const level = useAppSelector((state) => state.user.user?.level || 0);
  const { helpIconRef } = useContext(IntroContext);

  const { helpTextModal } = useModal();
  const location = useLocation();
  const helpType = useHelpTypeFunction(location);
  const checkBoosts = useBoostHelp();
  const [key, setKey] = useState<string>(uuidv4());

  const [activeHelp, setActiveHelp] = useState(
    JSON.parse(localStorage.getItem('help') || 'true'),
  );

  useEffect(() => {
    const handleStorageChange = (): void => {
      setActiveHelp(JSON.parse(localStorage.getItem('help') || 'true'));
    };

    window.addEventListener('storage', handleStorageChange);

    return (): void => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    setKey(uuidv4());
  }, [location.pathname]);

  return (
    activeHelp &&
    level < ENV.MIN_LEVEL_FOR_HELPICON && (
      <Assistant
        ref={helpIconRef as React.Ref<HTMLDivElement>}
        onClick={() => {
          if (helpType) helpTextModal(helpType);
        }}
        className={`helpIcon ${checkBoosts ? 'helpIconBoost' : ''} pointer-events-auto`}
        characterImage={{ main: helpAssistantPng, webp: helpAssistantWebp }}
        label="Help?"
        pictureAnimation={{
          key,
          initial: {
            scale: 0.75,
            filter: 'drop-shadow(0px 0px 0px rgba(0, 0, 0, 0))',
          },
          animate: {
            scale: [null, 1.25, 1],
            filter: [
              null,
              'drop-shadow(0px 0px 4px #82E024)',
              'drop-shadow(0px 0px 0px rgba(0, 0, 0, 0))',
            ],
          },
          transition: {
            ease: 'easeIn',
            duration: 0.4,
            delay: 2,
          },
        }}
      />
    )
  );
};

export default HelpIcon;
